import { ArrowUpRight } from 'lucide-react'

export default function SupportMaterialCard({
  icon: Icon,
  iconClass = 'text-[#2862B9]',
  iconBoxClass = 'bg-[#EFF7FF]',
  tag = '',
  status = '',
  title = '',
  description,
  sectionsLabel = 'Seções incluídas:',
  items = [],
  meta,
  href = '#',
  target,
  rel,
  chipClass,
  bulletClass = 'text-[#FF4D1C]',
}) {
  return (
    <div className="flex w-full flex-col rounded-[10px] border border-[#D9D9D9] bg-white p-6">
      {Icon && (
        <div
          className={`mb-4 flex h-12 w-12 items-center justify-center rounded-[10px] ${iconBoxClass}`}
        >
          <Icon size={24} className={iconClass} />
        </div>
      )}

      {(tag || status) && (
        <div className="flex items-center gap-2 pb-6">
          {tag && (
            <span
              className={
                chipClass ??
                'rounded bg-[#FFEDD4] px-2 py-1 font-jetbrains-mono text-xs uppercase tracking-[0.05em] text-[#CA3500]'
              }
            >
              {tag}
            </span>
          )}
          {status && (
            <span
              className={
                chipClass ??
                'rounded border border-[#FFB86A] bg-[#FFEDD4] px-2 py-1 font-jetbrains-mono text-xs uppercase tracking-[0.05em] text-[#CA3500]'
              }
            >
              {status}
            </span>
          )}
        </div>
      )}

      {title && (
        <h3 className="font-inter-regular text-lg text-[#454545]">{title}</h3>
      )}

      {description && (
        <p className="mt-3 font-inter-regular text-sm leading-relaxed text-[#4A5565]">
          {description}
        </p>
      )}

      {items.length > 0 && (
        <p className="mt-6 mb-2 font-inter-regular text-xs tracking-[0.05em] text-[#6A7282]">
          {sectionsLabel}
        </p>
      )}

      {items.length > 0 && (
        <ul className="mt-4 flex flex-col gap-1.5">
          {items.map((item, index) => (
            <li
              key={index}
              className="flex items-start gap-1.5 font-inter-regular text-xs text-[#4A5565]"
            >
              <span className={bulletClass}>▸</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      )}

      {/* Rodapé em 2 linhas como no Figma: meta em cima; link com texto à
          esquerda e seta ancorada à direita (SPACE_BETWEEN) */}
      <div className="mt-6 flex flex-col gap-4 border-[#E5E7EB] border-t pt-4">
        {meta && (
          <span className="font-jetbrains-mono text-xs text-[#6A7282]">
            {meta}
          </span>
        )}
        <a
          href={href}
          target={target}
          rel={rel}
          className="flex items-center justify-between font-inter-regular text-sm text-[#4A5565] transition-opacity hover:opacity-70"
        >
          <span>Acessar Material</span>
          <ArrowUpRight size={16} strokeWidth={1} className="text-[#4A5565]" />
        </a>
      </div>
    </div>
  )
}
